/* eslint-disable no-shadow */
/* eslint-disable import/extensions */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { swalMessages } from '@auteco/constants';
import YoutubePageDetail from 'src/pages/InsigthPage/Youtube/YoutubePageDetail';
import useLocalStorage from 'src/utils/hooks/useLocalStorage';
import {
  gp3,
  updateList,
  deleteList,
  searchVideos,
  getVideosId,
  createVideoToList,
  analyzeVideos,
  deleteVideo,
  getListTags,
  deleteAnalysis,
  postSemanticClassification,
  getComments,
  getCommentsbyVideoId,
  evaluateFeeling,
  getFeelingsById,
  getFeelings,
  cloudWords,
  confirmContext,
  cloudWordsById,
  getStatisticsPerVideo,
  heaters,
} from 'src/services/youtubeService';

const YoutubeDetailContainer = () => {
  const [itemToList, setItemToList] = useLocalStorage('itemToList', false);
  const [listItem, setListItem] = useState(itemToList);
  const [open, setOpen] = useState(false);

  const [isEdit, setIsEdit] = useState(true);
  const [force, setForce] = useState(false);
  const [search, setSearch] = useState('');

  const [isAnalyzed, setIsAnalyzed] = useState({
    loading: false,
    isAnalyzed: '',
  });
  const [feelings, setFeelings] = useState({ loading: false, feelings: [] });
  const [videos, setVideos] = useState({ loading: false, videos: [] });
  const [heater, setHeater] = useState({ loading: false, heater: [] });
  const [words, setWords] = useState({ loading: false });
  const [gp3Comments, setGp3Commnets] = useState({
    loading: false,
    gp3Comments: [],
  });
  const [temperature, setTemperature] = useState(0.5);
  const [videoList, setVideoList] = useState({});
  const [pageWords, setPageWords] = useState(50);
  const [comments, setComments] = useState({});
  const [tab, setTab] = useState(0);

  const [activeStep, setActiveStep] = useState(0);
  const [activeStepSearch, setActiveStepSearch] = useState(0);
  const history = useHistory();

  const onChange = (event, type) => {
    setListItem({ ...listItem, [type]: event.target.value });
  };

  /*= =======================================================================
  Update list after pressing analyze button
======================================================================== */
  const handleEditList = async () => {
    const response = await updateList(listItem);
    if (response.success === 1) {
      setItemToList(listItem);
    }
    setIsEdit(true);
  };

  /*= =======================================================================
  get cloud words
======================================================================== */
  const reloadCloudWords = async () => {
    setWords({ loading: true });
    const response = await cloudWords(
      listItem._id,
      itemToList.analisis[activeStep].analisisId,
      pageWords,
    );
    if (response) {
      setWords({ loading: true, response });
    }
  };

  /*= =======================================================================
  get cloud words by id
======================================================================== */
  const handleCloudWordsById = async (listId, AnalysisId, VideoId, limit) => {
    setWords({ loading: true });
    const response = await cloudWordsById(listId, AnalysisId, VideoId, limit);
    if (response) {
      setWords({ loading: true, response });
    }
  };

  /*= =======================================================================
  Get All video item List
  ======================================================================== */

  const reloadStadisticsPerVideo = async (videoId) => {
    const stadistics = await getStatisticsPerVideo(videoId);
    return stadistics;
  };

  const reloadVideoSelected = async () => {
    setVideos({ loading: true, videos: [] });
    const videos = await getVideosId(listItem._id);
    if (videos[0].videos) {
      const result = videos[0].videos.map(({ id }) => reloadStadisticsPerVideo(id.videoId));
      Promise.all(result).then((videos) => {
        const vid_ = [];
        videos.forEach((vid) => {
          vid_.push(vid);
        });
        setVideos({ loading: false, videos: vid_ });
      });
    } else {
      setVideos({ loading: false, videos: [] });
    }
  };

  /*= =======================================================================
  Get All comments
======================================================================== */
  const reloadComments = async () => {
    setComments({ loading: true, comments: [] });
    const response = await getComments(
      listItem._id,
      listItem.analisis[activeStep].analisisId,
    );
    if (response) {
      setComments({ comments: response, loading: false });
    }
  };

  /*= =======================================================================
  Get All Feelings
======================================================================== */
  const reloadFeelings = async () => {
    setFeelings({ loading: true, feelings: [] });
    const feelings = await getFeelings(
      itemToList._id,
      itemToList?.analisis[activeStep].analisisId,
    );
    if (feelings) {
      setFeelings({
        loading: false,
        feelings,
      });
    }
  };

  /*= =======================================================================
   Request feelings by videoId
======================================================================== */

  const reloadgp3Comments = async () => {
    setGp3Commnets({
      loading: true,
    });

    const body = {
      listaId: listItem._id,
      analisisId: listItem.analisis[activeStep]?.analisisId,
      temperature,
      force,
    };
    const gp3Coment = await gp3(body);
    if (gp3Coment) {
      setGp3Commnets({
        loading: false,
        gp3Coment: gp3Coment.resumenes.map((resum) => {
          if (!resum.error) {
            return resum.choices[0].text;
          }
          return [];
        }),
      });
    }
  };

  const reloadHeaters = async () => {
    const body = {
      listaId: listItem._id,
      analisisId: listItem.analisis[activeStep]?.analisisId,
    };
    const heater = await heaters(body);
    if (heater) {
      setHeater({
        loading: false,
        heater,
      });
    }
  };

  /*= =======================================================================
 load List to update
======================================================================== */
  const reloadList = async () => {
    const list = await getListTags();
    const newList = list.find((element) => element._id === listItem._id);
    if (newList) {
      setItemToList(newList);
      setListItem(newList);
    }
  };

  /*= =======================================================================
   Request feelings by videoId
======================================================================== */
  const handleFeelingsById = async (videoId) => {
    setFeelings({ loading: true, feelings: [] });
    const feelings = await getFeelingsById(
      listItem._id,
      listItem.analisis[activeStep].analisisId,
      videoId,
    );
    if (feelings) {
      setFeelings({
        loading: false,
        feelings,
      });
      handleCloudWordsById(
        listItem._id,
        listItem.analisis[activeStep].analisisId,
        videoId,
        pageWords,
      );
    }
  };

  /*= =======================================================================
    Recharge according to analysis id
======================================================================== */
  useEffect(() => {
    if (
      Array.isArray(listItem.analisis)
      && typeof listItem.analisis[0]?.analisisId === 'string'
    ) {
      reloadFeelings();
      reloadComments();
      reloadgp3Comments();
      reloadHeaters();
      reloadCloudWords();
    }
  }, [activeStep, listItem]);

  useEffect(() => {
    if (
      Array.isArray(listItem.analisis)
      && typeof listItem.analisis[0]?.analisisId === 'string'
    ) {
      reloadgp3Comments();
    }
  }, [temperature, force]);

  /*= =======================================================================
      get All video when load
  ======================================================================== */
  useEffect(async () => {
    await reloadVideoSelected();
  }, []);

  const handleChangeLimit = async (event) => {
    setPageWords(event.target.value);
  };

  /*= =======================================================================
 Delete All list
======================================================================== */
  const handleDeleteListItem = () => {
    swal(swalMessages.DELETE_CONFIRM).then(async (willDelete) => {
      if (willDelete) {
        const response = await deleteList(listItem._id);
        if (response.success === 1) {
          setItemToList('');
          history.push('/insigth/youtube');
        }
      }
    });
  };

  /*= =======================================================================
 Button Analize videos
======================================================================== */
  const handleAnalyzeVideos = async () => {
    setIsAnalyzed({ loading: true });
    const isAnalyzed = await analyzeVideos({ _id: listItem._id });
    if (isAnalyzed.success === 1) {
      setIsAnalyzed({
        loading: false,
        isAnalyzed,
      });
      reloadList();
    }
  };

  /*= =======================================================================
 Remove video from list
======================================================================== */
  const handleDeleteVideoList = async (videoId) => {
    const isDelete = await deleteVideo(listItem._id, videoId);
    if (isDelete.success === 1) {
      reloadVideoSelected();
    }
  };

  /*= =======================================================================
 Remove video from list
======================================================================== */
  const handleAddVideoItemList = async (value) => {
    const response = await createVideoToList(listItem._id, value);
    if (response.success === 1) {
      reloadVideoSelected();
    }
  };

  /*= =======================================================================
 get comments by id video
======================================================================== */
  const handleCommetsByVideoId = async (videoId) => {
    setComments({ loading: true, comments: [] });
    const comments = await getCommentsbyVideoId(
      listItem._id,
      listItem.analisis[activeStep].analisisId,
      videoId,
    );
    if (comments) {
      setComments({ comments, loading: false });
    }
  };

  /*= =======================================================================
 search video from youtube
======================================================================== */
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  /*= =======================================================================
 press button search video from  youtube
======================================================================== */
  const onSearch = async (nextPage) => {
    setVideoList({ loading: true });
    const video = await searchVideos(search, nextPage);
    if (video) {
      setOpen(true);
      const result = video.items.map(({ id }) => reloadStadisticsPerVideo(id.videoId));
      Promise.all(result).then((videos) => {
        const vid_ = [];
        videos.forEach((vid) => {
          vid_.push(vid);
        });
        setVideoList({ loading: false, videoList: vid_, pageInfo: video });
      });
    } else {
      setVideoList({ loading: false, videoList: [] });
    }
  };

  /*= =======================================================================
 Change Tap list
======================================================================== */
  const handleChangeTap = (event, newValue) => {
    setTab(newValue);
  };

  /*= =======================================================================
 event press like or dislike feeling
======================================================================== */
  const handleEvaluateSentiment = async (feling) => {
    await evaluateFeeling(feling);
  };

  /*= =======================================================================
 order feeling by scoore
======================================================================== */
  const orderFeelingBy = Array.isArray(feelings.feelings)
    && feelings.feelings
      .map((feelin) => feelin?.sentences.map(({ sentiment, text }) => ({
        sentiment,
        text,
        videoId: feelin.videoId,
        listaId: feelin.listaId,
        analisisId: feelin.analisisId,
      })))
      .reduce((reducedSentences, sentences) => {
        reducedSentences = reducedSentences.concat(sentences);
        return reducedSentences;
      }, [])
      .sort((scoreA, scoreB) => {
        const a = scoreA?.sentiment.score;
        const b = scoreB?.sentiment.score;
        return tab === 0 ? b - a : a - b;
      });

  /*= =======================================================================
semantic selection of feeling
======================================================================== */
  const handleSelectOption = async (body) => {
    await postSemanticClassification(body);
  };

  const handleRemoveAnalysis = async () => {
    const isDelete = await deleteAnalysis(
      listItem._id,
      listItem.analisis[activeStep].analisisId,
    );
    if (isDelete.success === 1) {
      await reloadList();
    }
  };

  const handleConfirmContext = async (value) => {
    await confirmContext(value);
  };

  const handleNextSearchVideo = () => {
    setActiveStepSearch((prevActiveStep) => prevActiveStep + 1);
    const { nextPageToken } = videoList.pageInfo;
    const nextPage = `pageToken=${nextPageToken}`;
    onSearch(nextPage);
  };

  const handleBackSearchVideo = () => {
    setActiveStepSearch((prevActiveStep) => prevActiveStep - 1);
    const { prevPageToken } = videoList.pageInfo;
    const backPage = `prevPageToken=${prevPageToken}`;
    onSearch(backPage);
  };

  const handleClose = () => setOpen(false);

  const handleForzeCommets = () => {
    setForce(!force);
  };

  return (
    <YoutubePageDetail
      tab={tab}
      open={open}
      words={words}
      search={search}
      videos={videos}
      isEdit={isEdit}
      heater={heater}
      comments={comments}
      listItem={listItem}
      pageWords={pageWords}
      videoList={videoList}
      activeStep={activeStep}
      isAnalyzed={isAnalyzed}
      gp3Comments={gp3Comments}
      temperature={temperature}
      feelings={orderFeelingBy}
      loadingFeelings={feelings}
      handleClose={handleClose}
      onChange={onChange}
      onSearch={onSearch}
      setIsEdit={setIsEdit}
      reloadFeelings={reloadFeelings}
      handleSearch={handleSearch}
      setActiveStep={setActiveStep}
      onEditList={handleEditList}
      onDelete={handleDeleteListItem}
      handleChangeTap={handleChangeTap}
      activeStepSearch={activeStepSearch}
      handleChangeLimit={handleChangeLimit}
      confirmContext={handleConfirmContext}
      handleForzeCommets={handleForzeCommets}
      handleFeelingsById={handleFeelingsById}
      handleSelectOption={handleSelectOption}
      handleAnalyzeVideos={handleAnalyzeVideos}
      onChangeTemperature={(event, newValue) => setTemperature(newValue)}
      handleRemoveAnalysis={handleRemoveAnalysis}
      evaluateSentiment={handleEvaluateSentiment}
      addToVideoItemList={handleAddVideoItemList}
      handleNextSearchVideo={handleNextSearchVideo}
      handleBackSearchVideo={handleBackSearchVideo}
      handleDeleteVideoList={handleDeleteVideoList}
      handleCommetsByVideoId={handleCommetsByVideoId}
    />
  );
};

export default YoutubeDetailContainer;
